import CbdMenu from "../../model/cbd/CbdMenu";

/**
 *
 * @param {AaasMenu[]} aaasMenuList
 * @returns {CbdMenu[]}
 */
export function transferList(aaasMenuList) {
  if (!aaasMenuList || aaasMenuList.length === 0) {
    return [];
  }
  let cbdMenuList = [];
  for (const aaasMenu of aaasMenuList) {
    cbdMenuList.push(transfer(aaasMenu));
  }
  return cbdMenuList;
}

/**
 *
 * @param {AaasMenu} aaasMenu
 * @returns {CbdMenu|null}
 */
export function transfer(aaasMenu) {
  if (aaasMenu == null) {
    return null;
  }
  let cbdMenu = new CbdMenu();
  cbdMenu.appId = aaasMenu.appCode;
  cbdMenu.code = aaasMenu.menuCode;
  cbdMenu.hiddenFlag = aaasMenu.hiddenFlag;
  cbdMenu.icon = aaasMenu.menuNoActiveIcon;
  cbdMenu.id = aaasMenu.menuId;
  // cbdMenu.levels = 1;
  // cbdMenu.linkedList = [];
  cbdMenu.menuTips = aaasMenu.menuTips;
  cbdMenu.name = aaasMenu.menuName;
  cbdMenu.nodeId = aaasMenu.nodeId;
  cbdMenu.nodeParentId = aaasMenu.nodeParentId;
  cbdMenu.num = aaasMenu.menuSort;
  cbdMenu.parentId = aaasMenu.menuPid;
  cbdMenu.url = aaasMenu.menuRouterUrl;
  cbdMenu.children = transferList(aaasMenu.children);
  return cbdMenu;
}

export default {
  transferList,
  transfer
}
